import {urlSiteEntryIds, urlSiteReadingsById, urlSiteReadings, urlDeviceReadings} from '../database/apiUrls'
import {apiFormat, hoursDiff, hoursAdd} from '../timeFunctions/timeFns';
import {firstFilter, dateSort, lastFilter} from './helperfunctions'

/* get day 1, get last day. if same devices stop. 
  if not same devices, get day 2. 
  repeat until all devices have start and stop readings or no days left*/
export async function SiteAncientHistory (ss, siteId, from, until) {
  if (singleBlock (from, until)) {
    return await SiteHistory (ss, siteId, from, until)
  }
  else {
    let result = {data: {data: {raw_data:[]}}}
    while (Math.abs(hoursDiff(from, until)) >= 24) {
      const part1 = await SiteHistory (ss, siteId, from, hoursAdd(from, 24))
      const part2 = await SiteHistory (ss, siteId, hoursAdd (until, -24), until)
      result = shConcat (result, part1)
      result = shConcat (result, part2)
      if (dataComplete (part1, part2))
        break;
      from = hoursAdd(from, 24)
      until = hoursAdd(until, -24)
    }
    return result
  }
}
export function singleBlock (from, until) {
  return Math.abs(hoursDiff(from, until)) <= 48
}

function dataComplete (part1, part2) {
  if (Array.isArray(part1?.data?.data?.raw_data) && Array.isArray(part2?.data?.data?.raw_data)) {
    const byDate = dateSort(part1.data.data.raw_data, "ReadTime");
    const firsts = firstFilter(byDate, "DeviceId")
    const byDate2 = dateSort(part2.data.data.raw_data, "ReadTime")
    const lasts = lastFilter(byDate2, "DeviceId");
    return deviceMatch(firsts, lasts)
  }
  else
    return true
}
export function toUpper(hist) {
  return hist?.data?.data?.raw_data?.map(i => i.DeviceId = i.DeviceId.toUpperCase())
}
function deviceMatch (firsts, lasts) {
  if (firsts.length === lasts.length) {
    firsts.sort((a, b) => a.DeviceId.localeCompare (b.DeviceId))
    lasts.sort((a, b) => a.DeviceId.localeCompare (b.DeviceId))
    return firsts.every((item, index) => item.DeviceId === lasts[index].DeviceId)
  }
  return false
}
function shConcat (result, part2) {
  if (Array.isArray(result?.data?.data?.raw_data) && Array.isArray (part2?.data?.data?.raw_data))
    result.data.data.raw_data = result.data.data.raw_data.concat(part2.data.data.raw_data)

  return result
}
export async function SiteHistory(ss, siteId, from, until) {
  const url = urlSiteReadings(siteId, apiFormat(from), apiFormat(until), 24000)
  return await ss.apiData(url)  
}

export async function SiteHistoryId(ss, siteId, from, until) {
  const idResp = await ss.apiData(urlSiteEntryIds(siteId, apiFormat(from), apiFormat(until)))
  const startId= idResp?.data?.startId
  const endId = idResp?.data?.endId
  if (startId && endId) {
    const urlRead = urlSiteReadingsById (siteId, startId, endId)
    return await ss.apiData(urlRead)  
  }
  return idResp;
}
export function isComputableReading(config, rawVal, index) {
  const num = Number(rawVal);
  if (num === 4294967295 || num === -1) 
    return true
  if (Number.isNaN(num))
    return false
  if (config?.sensors?.length >= index && config.sensors[index]?.sensor_type !== "FF") {
    if (config.sensors[index]?.sensor_type === '01') 
      return true
    if (Number.isNaN(config.sensors[index]?.factor))
      return false
    if (config.sensors[index]?.modbus_data_format === '84')
      return true   //imr not needed
    if (Number.isNaN(config.sensors[index]?.initial_meter_read))
      return false
    return true 
  }
  return false
}
export function computeReading(config, rawVal, index) {
  if (config?.sensors?.length >= index && config.sensors[index]?.sensor_type !== "FF") {
    const num = Number(rawVal);
    if (num === 4294967295 || num === -1) 
      return 4294967295
    if (config.sensors[index]?.sensor_type === '01') {
      return Number(rawVal)
    }
    const given_factor = Number(config.sensors[index]?.factor ?? 1)
    const factor = given_factor === 0 ? 1 : given_factor
    if (config.sensors[index]?.modbus_data_format === '84')
      return conv32bitFloat(rawVal) * factor
    const imr = config.sensors[index]?.initial_meter_read ?? 0;
    return Number(num * factor + Number(imr));
  }
  return "";
}
 // input float bytes, return number. 1078530010 returns 3.1415927410125732
export function conv32bitFloat(flt) {
  const buffer = new ArrayBuffer(4);
  const dataView = new DataView(buffer);
  dataView.setInt32(0, flt, true )
  const float32Array = new Float32Array(buffer);
  const floatValue = float32Array[0];
  // console.log(floatValue);
  return floatValue
}
export async function chunkyHistory(ss, siteId, radioId, from, until) {
  const increment = 48
  let start = from
  let end = singleBlock(from, until) ? until : hoursAdd(start, increment)
  let total = []
  while (start < until) {
    const chunk = await readings (ss, siteId, radioId, start, end)
    total = total.concat (chunk?.data?.data?.readings)
    start = hoursAdd (start, increment)
    end = hoursAdd (end, increment)
    if (end > until)
      end = until
  } 
  return total
}
export function readings (ss, siteId, radioId, from, to) {
  const url = urlDeviceReadings(siteId, radioId, apiFormat(from), apiFormat(to), 5000)
  return ss.apiData(url);
}

